/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateWorkScheduleCommand
 */
export interface CreateWorkScheduleCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkScheduleCommand
     */
    name: string;
}

/**
 * Check if a given object implements the CreateWorkScheduleCommand interface.
 */
export function instanceOfCreateWorkScheduleCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CreateWorkScheduleCommandFromJSON(json: any): CreateWorkScheduleCommand {
    return CreateWorkScheduleCommandFromJSONTyped(json, false);
}

export function CreateWorkScheduleCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWorkScheduleCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function CreateWorkScheduleCommandToJSON(value?: CreateWorkScheduleCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

